import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const SOPsPage = () => {
  return (
    <Box sx={{ py: 3, px: 2, minHeight: '60vh' }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 3,
          background: 'linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)',
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
          Standard Operating Procedures (SOPs)
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This is a placeholder for the SOP&apos;s workspace. Here you can add navigation,
          upload/download, and management of SOP documents specific to this study or project.
        </Typography>
      </Paper>
    </Box>
  );
};

export default SOPsPage;


